"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetadata = exports.setMetadata = void 0;
require("reflect-metadata");
function setMetadata(target, name, value) {
    Reflect.defineMetadata("custom:annotations:" + name, value, target, "custom:annotations:" + name);
}
exports.setMetadata = setMetadata;
function getMetadata(target, name) {
    const keys = Reflect.getMetadataKeys(target, "custom:annotations:" + name);
    const decorators = keys
        .filter((key) => key.toString().startsWith("custom:annotations:"))
        .reduce((values, key) => {
        const currValues = Reflect.getMetadata(key, target, "custom:annotations:" + name);
        return values.concat(currValues);
    }, []);
    return decorators[0];
}
exports.getMetadata = getMetadata;
